// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { GetInvoicesApiParameter } from "@insite/client-framework/Services/InvoiceService";
import { getInvoicesDataView } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import constants from "@store/constants";
import updateDraftParameter from "@store/Framework/Store/Greif/Pages/InvoiceHistory/Handlers/UpdateDraftParameter";
import debounce from "lodash/debounce";
import { useCallback } from "react";

export const useInvoiceHistoryState = () => {
    return useAppSelector(state => state.greif.pages.invoiceHistory);
};

export const useInvoiceHistoryDataView = (parameter?: GetInvoicesApiParameter) => {
    return useAppSelector(state => {
        return getInvoicesDataView(state, parameter || state.greif.pages.invoiceHistory.parameter);
    });
};

export const useInvoiceHistoryDebouncedUpdateDraftParameter = () => {
    const dispatch = useAppDispatch();

    return useCallback(
        debounce(
            (parameter: GetInvoicesApiParameter) => dispatch(updateDraftParameter(parameter)),
            constants.searchDebounceDelay,
        ),
        [],
    );
};
